import React from "react";
import { withRouter } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import HeaderContent from "../../components/layout/components/HeaderContent";
import FindCommercialDocumentFeaturesComponent from "./components/FindCommercialDocumentFeaturesComponent";

const FindCommercialDocumentFeatures = () => {
  const breadcrumb = [
    {
      link: "/findCommercialDocumentFeatures",
      title: "Find Commercial Document Features",
    },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Find Commercial Document Features"
        isNotHaveSchoolFilter
      />

      <Card>
        <CardContent>
          <FindCommercialDocumentFeaturesComponent />
        </CardContent>
      </Card>
    </>
  );
};

export default withRouter(FindCommercialDocumentFeatures);
